import { DestroyRef, Inject, Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ConfType, Depot, Driver, DriverName, DriverNote, Tour } from '@models/*';
import { Store } from '@ngrx/store';
import { StoreDriver } from '@appstore/*';
import { ToastService } from '../../core/services/toast.service';
import { RestService } from '../../core/services/rest.service';
import { ErrorService } from '../../core/services/error.service';
import { NetworkService } from '../../core/services/network.service';
import { APP_CONFIG, AppConfig } from '../../config/app-config';
import { OpcoService } from '../../services/opco.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class TourService extends RestService {
  constructor(
    @Inject(APP_CONFIG) appConfig: AppConfig,
    private toastService: ToastService,
    http: HttpClient,
    errorService: ErrorService,
    networkService: NetworkService,
    private store: Store,
    private readonly opcoService: OpcoService,
    private readonly destroyRef: DestroyRef,
    injector: Injector
  ) {
    super(appConfig, http, errorService, networkService, injector);
  }

  getDriverData(
    date: string,
    refreshMsg: boolean
  ): Observable<{
    depots: { [key: string]: Depot };
    tours: Tour[];
    driverId: number;
    driver: Driver;
    driverNames: { [key: string]: DriverName };
    driverNotes: { [key: string]: DriverNote[] };
    drivers: { [key: string]: Driver };
  }> {
    // TODO : investigate if this needs to be triggered explicitly to have the latest data available.
    // Initializing the opcos is already done in app.component.ts
    this.opcoService.initialize().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    return this.get(`${this.DRIVER_DATA_URL}?date=${encodeURIComponent(date)}`).pipe(
      tap((res) => {
        if (!res || res instanceof HttpErrorResponse || res.error || !res.status) {
          throw new Error('GetDriverData failed');
        }
        if (!res.data || !res.data.driver) {
          throw new Error('GetDriver failed');
        }
        this.store.dispatch(new StoreDriver(res.data.driver));
        if (refreshMsg) {
          this.toastService.generateSuccessToast(ConfType.DATA_REFRESHED);
        }
      }),
      map((res) => res.data)
    );
  }

  getTour(tourId: number): Observable<Tour | null> {
    return this.get(`${this.TOUR_URL}/${tourId}`).pipe(
      map((res) => (res instanceof HttpErrorResponse || res.error ? null : res.data))
    );
  }
}
